import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const InfoIcon = ({ bookId, customClass }) => (
  <Link className={ ` hover ${customClass}` }  to={ `/reps/books/${bookId}` }>
    <i className='fa fa-book rep-apts-index__header__details-button' />
    <span className='hover__text'>Office Details</span>
  </Link>
);

InfoIcon.propTypes = {
  bookId: PropTypes.string,
  customClass: PropTypes.string
};

InfoIcon.defaultProps = {
  customClass: ''
};
export default InfoIcon;



// WEBPACK FOOTER //
// ./app/components/reps/InfoIcon.jsx